import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
	ONBOARDING_ACTIVATION_ENTER_VOUCHER,
	CONTACT_SUBMIT,
	ONBOARDING_VOUCHER_ACCEPTED,
	ONBOARDING_VOUCHER_SEND_AGAIN,
	ONBOARDING_VOUCHER_INVALID_PATTERN_TITLE,
} from '../../constants/Copy';
import './Voucher.scss';
import Button, { BUTTON_KIND_BRAND } from '../common/buttons/button/Button';
import ErrorMessage from '../onboarding/form/ErrorMessage';

const MAX_CODE_LENGTH = 12;

const Voucher = ({ voucher, setVoucher, isFormOpen, voucherCheckProps }) => {
	const [showVoucherForm, setShowVoucherForm] = useState(isFormOpen);
	const { setSendCode, isValid, resetVoucherCheck, verifyError } = voucherCheckProps;

	function removeSpacesAndLineBreaks(voucherCode) {
		return voucherCode.replace(/(\s|\r\n|\n|\r)/gm, '');
	}

	function handleSubmit(e) {
		e.preventDefault();
		setSendCode(true);
	}

	function handleOnPaste(e) {
		e.preventDefault();
		const value = removeSpacesAndLineBreaks(e.clipboardData.getData('Text'));
		setVoucher(value);
	}

	function onChangeCodeField(e) {
		setVoucher(removeSpacesAndLineBreaks(e.target.value));
	}

	return (
		<div className="voucher">
			{showVoucherForm ? (
				isValid ? (
					<div className="voucher__success">{ONBOARDING_VOUCHER_ACCEPTED}</div>
				) : (
					<form method="post" className="onboarding__form" onSubmit={handleSubmit}>
						<div className="onboarding__form__input">
							<label htmlFor="input-voucher">{ONBOARDING_ACTIVATION_ENTER_VOUCHER}</label>
							<div className="voucher__input">
								<input
									autoFocus
									id="input-voucher"
									onPaste={handleOnPaste}
									value={voucher}
									maxLength={MAX_CODE_LENGTH}
									type="text"
									className="voucher__input-field"
									onChange={onChangeCodeField}
									pattern="^[a-zA-Z0-9]+$"
									title={ONBOARDING_VOUCHER_INVALID_PATTERN_TITLE}
								/>
								{voucher && (
									<i
										className="icon icon-close"
										onClick={() => {
											setVoucher('');
											resetVoucherCheck();
										}}
									/>
								)}
							</div>
							{verifyError && <ErrorMessage error={verifyError} />}
						</div>

						<Button disabled={!voucher.length} kind={BUTTON_KIND_BRAND}>
							{verifyError ? ONBOARDING_VOUCHER_SEND_AGAIN : CONTACT_SUBMIT}
						</Button>
					</form>
				)
			) : (
				<button
					className="onboarding__link"
					onClick={() => {
						setShowVoucherForm(!showVoucherForm);
					}}
				>
					{ONBOARDING_ACTIVATION_ENTER_VOUCHER}
				</button>
			)}
		</div>
	);
};

Voucher.propTypes = {
	isFormOpen: PropTypes.bool,
	setIsVoucherValidOnActivate: PropTypes.func,
};

export default Voucher;
